import { forwardRef } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, Navigate as RouterNavigate } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

// Use the router's real locale-prefixed URL so NavLink keeps its active state.
// localizePath leaves external URLs, telephone/email links, hashes and assets alone.
export const Link = forwardRef(function LocalizedLink({ to, ...props }, ref) {
  const { localizePath } = useLanguage();
  return <RouterLink {...props} ref={ref} to={localizePath(to)} />;
});

export const NavLink = forwardRef(function LocalizedNavLink({ to, ...props }, ref) {
  const { localizePath } = useLanguage();
  return <RouterNavLink {...props} ref={ref} to={localizePath(to)} />;
});

export function Navigate({ to, ...props }) {
  const { localizePath } = useLanguage();
  return <RouterNavigate {...props} to={localizePath(to)} />;
}
